import { ChangeMatrixCommand } from "ags/commands/change-matrix-command";
import { updateFieldsAfterFreespins } from "ags/commands/update-fields-after-freespins";
import { CloseCommand } from "appworks/commands/comms/close-command";
import { Components } from "appworks/components/components";
import { gameState } from "appworks/model/game-state";
import { CurrencyService } from "appworks/services/currency/currency-service";
import { Services } from "appworks/services/services";
import { SoundService } from "appworks/services/sound/sound-service";
import { TranslationsService } from "appworks/services/translations/translations-service";
import { Contract } from "appworks/utils/contracts/contract";
import { Sequence } from "appworks/utils/contracts/sequence";
import { Timer } from "appworks/utils/timer";
import { gameiomModel } from "gameiom/model/gameiom-model";
import { wrapperImplementation } from "gameiom/wrapper/wrapper-implementation";
import { SlotBetService } from "slotworks/services/bet/slot-bet-service";
import { ExitFreespinsState } from "slotworks/state-machine/standard/states/exit-freespins-state";
export class AgsExitFreespinsState extends ExitFreespinsState {

    public onEnter(): void {
        const translations = Services.get(TranslationsService);

        const totalWin: number = gameState.getCurrentGame().getTotalWin();
        const creditSize: number = Services.get(SlotBetService).getCreditSize();

        let message: string;

        if (totalWin > 0) {
            const key = gameiomModel.displayCurrency ? "total_win_x" : "freespins_won_credits";
            const win = gameiomModel.displayCurrency ? Services.get(CurrencyService).format(totalWin, null, false) : (totalWin / creditSize);
            message = translations.get(key, { credits: win });
        } else {
            message = translations.get("fs_prompt_complete");
        }
        //Components.get(FooterComponent).showCustomMessage(message);
        super.onEnter();
    }

    public complete(): void {
        super.complete();
    }

    protected showPrompt(): Contract<void> {
        Services.get(SoundService).customEvent("stop_freespins");
        return super.showPrompt();
    }

    protected afterPrompt() {
        // Delay this to wait for any transitions to finish before resetting the message bar (PP-181 for example)
        // Timer.setTimeout(() => {
        //     Components.get(FooterComponent).showDefaultText();
        // }, 2000);

        return new Sequence<void>([
            () => CloseCommand(),
            () => super.afterPrompt()
        ]);
    }

    protected resetToTriggeringSpin(): Contract<void> {
        return this.updateFields();
    }

    protected resetMatrix(): Contract<void> {
        ChangeMatrixCommand();
        return Contract.empty();
    }

    protected updateFields(): Contract<void> {
        updateFieldsAfterFreespins();
        return Contract.empty();
    }
}
